import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/live-events")({
	component: LiveEventsLayout,
})

function LiveEventsLayout() {
	return <Outlet />
}
